<ng-scrollbar class="std-scrollbar flex-1" [appearance]="'compact'" orientation="vertical">
  <div class="flex my-2.5 mx-7 flex-col flex-1">
    <form class="flex flex-col h-full" #generalForm="ngForm" role="form">
      <app-input-upload
        [files]="model()?.files"
        label="Drag or click to upload files"
        placeholder="Drag or click to upload files"
        (filesChanged)="filesChanged($event)"
        (removeFile)="removeFile($event)"
        [allowMultipleFiles]="true"
      >
      </app-input-upload>

      <div class="flex gap-4">
        <app-floating-input
          [ngClass]="{
            'pointer-events-none': !canBeEdited(),
          }"
          [disabled]="!canBeEdited() || customIdDisabled"
          [required]="true"
          [(ngModel)]="model().invoice_number"
          (ngModelChange)="invoiceNumberChanged($event)"
          [minLength]="1"
          [maxLength]="10"
          patternErrorMessage="Already taken"
          name="invoice_number"
          label="Invoice Number"
          placeholder="Invoice Number"
          class="flex-1"
          [iconClass]="customIdDisabled ? 'icon-text-edit' : 'icon-text-revert'"
          (iconClick)="onCustomIdIconClick()"
        ></app-floating-input>

        <app-dropdown
          [disabled]="false"
          [required]="true"
          [(ngModel)]="model().status"
          (ngModelChange)="onStatusChange($event)"
          name="status"
          label="Status"
          placeholder="Status"
          [options]="statusOptions()"
          class="flex-1"
        ></app-dropdown>
      </div>

      <div class="flex gap-4">
        <app-input-calendar
          [disabled]="!canBeEdited()"
          [required]="true"
          [(date)]="model().invoice_date"
          name="invoice_date"
          placeholder="Invoice Date"
          class="flex-1"
        ></app-input-calendar>

        <app-input-calendar
          [required]="model().status === 'paid'"
          [(date)]="model().paid_date"
          [disabled]="model().status !== 'paid' || (!canBeEdited() && model().status !== 'paid')"
          [minStartDate]="model().invoice_date"
          name="paid_date"
          [placeholder]="'Paid Date'"
          class="flex-1"
        ></app-input-calendar>
      </div>

      <label class="flex gap-1 text-navy-600 text-xs mt-2 ml-1 mb-0.5">
        <span class="font-semibold">Invoice Description</span>
        <span class="font-normal">(optional)</span>
      </label>
      <div (click)="textAreaElement.focus()" class="textarea-wrapper cursor-text">
        <textarea
          class="flex"
          #textAreaElement
          cdkTextareaAutosize
          name="note"
          [(ngModel)]="model().description"
        ></textarea>
      </div>
    </form>
  </div>
</ng-scrollbar>
